export var ActionRefreshScope;
(function (ActionRefreshScope) {
    ActionRefreshScope[ActionRefreshScope["None"] = 0] = "None";
    ActionRefreshScope[ActionRefreshScope["Self"] = 1] = "Self";
    ActionRefreshScope[ActionRefreshScope["OwningFolder"] = 2] = "OwningFolder";
    ActionRefreshScope[ActionRefreshScope["Tree"] = 3] = "Tree";
    ActionRefreshScope[ActionRefreshScope["TreeAndOwningFolder"] = 4] = "TreeAndOwningFolder";
})(ActionRefreshScope || (ActionRefreshScope = {}));
;
